import React from 'react';
import { TemplatesList } from '../../../../enums/TemplatesList';
import DefaultHeroSection from '../../../Templates/DefaultTemplate/Sections/GetInTouch/HeroSection/HeroSection';
import ModernHeroSection from '../../../Templates/ModernTemplate/Sections/GetInTouch/HeroSection/HeroSection';
import { Section } from '../../../../interfaces/Section';
import { IExternalLink, IOpeningTime } from '../../../../interfaces/professional/Professional';
import { FormSectionProps } from '../FormSection/FormSection';

export interface GetInTouchHeroSectionProps extends Section {
  openingTime: IOpeningTime;
  email: string;
  phone: string;
  externalLinks: Array<IExternalLink>;
}

const HeroSection = (props: GetInTouchHeroSectionProps & FormSectionProps) => {
  if (props.template === TemplatesList.MODERN) {
    return <ModernHeroSection {...props} />;
  }
  return <DefaultHeroSection {...props} />;
};

export default HeroSection;
